import * as React from "react";
import { forwardRef } from "react";
const SvgLeadingIcon = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("g", { id: "leading icon" }, /* @__PURE__ */ React.createElement("path", { id: "Vector", d: "M11 19C15.4183 19 19 15.4183 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19Z", stroke: "#7B8784", style: {
  stroke: "#7B8784",
  stroke: "color(display-p3 0.4824 0.5294 0.5176)",
  strokeOpacity: 1
}, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { id: "Vector_2", d: "M20.9999 21L16.6499 16.65", stroke: "#7B8784", style: {
  stroke: "#7B8784",
  stroke: "color(display-p3 0.4824 0.5294 0.5176)",
  strokeOpacity: 1
}, strokeLinecap: "round", strokeLinejoin: "round" })));
const ForwardRef = forwardRef(SvgLeadingIcon);
export { ForwardRef as ReactComponent };
